import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import App from "./App";
import { Toaster } from "react-hot-toast";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./MainComponents/GlobalContext.jsx";
import { NuqsAdapter } from "nuqs/adapters/react";
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <HelmetProvider>
    <Toaster position="top-center" reverseOrder={false} />
    <AuthProvider>
      <NuqsAdapter>
        <App />
      </NuqsAdapter>
    </AuthProvider>
  </HelmetProvider>
  /*  <React.StrictMode>
  </React.StrictMode> */
);
